import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';
// interface FieldListProps {
//   company_id?: number;
//   name?: string;
//   address?: string;
//   use_buildee_flg?: number;
//   use_roan_flg?:number;
//   use_gk_flg ?:number;
//   order?:string;
// }
const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_groups/list`),
    params: param,
  });
};

/**
 * 検索用のグループ設定一覧（使用中のみで、並び替え）
 *
 * @param {*} fieldId
 * @param {*} param
 * @returns
 */
const listForSearch = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_groups/list_for_search`),
    params: param,
  });
};

export const FieldGroupService = {
  list,
  listForSearch,
};
export default FieldGroupService;



// WEBPACK FOOTER //
// ./src/services/FieldGroups.js